import { createTheme } from '@mui/material/styles';

import { bgColors, redColors, typographyColors } from './colors';

const theme = createTheme({
  spacing: 8, // = default
  breakpoints: {
    values: {
      xs: 0,
      sm: 620, // default 600
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: 'Inter, Roboto, Helvetica, Arial, sans-serif',
    fontSize: 14,
    fontWeightRegular: 400,
    fontWeightBold: 600,
  },
  palette: {
    mode: 'dark',
    action: {
      disabledBackground: 'none',
      disabled: 'none',
    },
    background: {
      default: bgColors.dark,
      paper: bgColors.light,
    },
    primary: {
      main: redColors.dark,
    },
    secondary: {
      main: redColors.light,
    },
    typography: {
      light: typographyColors.light,
      dark: typographyColors.dark,
    },
  },
});

const displayFontFamily = 'Space Grotesk, Inter, Roboto, sans-serif';

theme.typography.h1 = {
  fontFamily: displayFontFamily,
  fontSize: 60,
  fontWeight: 700,
  lineHeight: '62px',
  letterSpacing: '-0.01em',
  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    lineHeight: '38px',
  },
};

theme.typography.h2 = {
  fontFamily: displayFontFamily,
  fontSize: 32,
  fontWeight: 700,
  lineHeight: '38px',
  letterSpacing: '-0.01em',
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    lineHeight: '30px',
  },
};

theme.typography.p1 = {
  fontSize: 22,
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
  },
};

theme.typography.p1b = {
  fontSize: 22,
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
  },
};

theme.typography.p2 = {
  fontSize: 20,
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
  },
};

theme.typography.p2b = {
  fontSize: 20,
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
  },
};

theme.typography.p3 = {
  fontSize: 16,
  [theme.breakpoints.down('md')]: {
    fontSize: 14,
  },
};

theme.typography.p3b = {
  fontSize: 16,
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: 14,
  },
};

// Shared "glass" material used by the sticky nav pill and any floating surface
// (toasts, banners) that should read as the same kind of element.
export const glassPanelSx = {
  bgcolor: 'rgba(36,38,42,0.78)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(238,240,242,0.14)',
} as const;

export default theme;
